const configrations = {
  backendBaseUrl: process.env.REACT_APP_BACKEND_BASE_URL || 'http://localhost:5000/api/v1',
  backendBaseDomain: process.env.REACT_APP_BACKEND_BASE_DOMAIN || 'http://localhost:5000'
    // backendBaseUrl: 'http://localhost:5000',
  };
  
  export default configrations;
